<script setup  lang="ts">
import { RouterView } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { useUserStore } from '@/stores/userStore';
import { useCalcFormStore } from "./stores/calcFormStore";

const userStore = useUserStore();

const calcFormStore = useCalcFormStore();
const user = computed(() => userStore.user); // Используем computed для отслеживания изменений user

const errorMessage = ref<string | null>(null);

onMounted(async () => {
  if (window.Telegram && window.Telegram.WebApp) {
    const tg = window.Telegram.WebApp;

    tg.expand();
    tg.ready();

    const tgDataUnsafe = tg.initDataUnsafe;
    const userFromTelegram = tgDataUnsafe.user;
    console.error('tg', tg);
    console.error('tgDataUnsafe', tgDataUnsafe);
    // console.error('tg.initData');
    // console.log(tg.initData);

    if (!userFromTelegram?.id) return;
    await userStore.fetchCurrentUser(String(userFromTelegram.id));
    if (!userStore.user) {
      // Если пользователь не найден, создаем нового пользователя
      const newUser = {
        telegram_id: userFromTelegram.id,
        first_name: userFromTelegram.first_name,
        last_name: userFromTelegram.last_name,
        username: userFromTelegram.username
      };
      await userStore.createUser(newUser);
    } else if (userStore.user.username && userStore.user.pay_method && calcFormStore.saveLogin) {
      calcFormStore.steamUsername = userStore.user.steam_username;
      calcFormStore.paymentType = userStore.user.pay_method;
    }

  } else {
    console.error("Telegram WebApp API is not available.");
    errorMessage.value = "This app must be run inside Telegram.";
  }
  
});
</script>
<template>
  <div v-if="errorMessage">{{ errorMessage }}</div>
  <RouterView v-else />
</template>
<style scoped>
</style>
